import {Command} from "./Command";
import {GamePlay} from "../model/game-play";
import {getDistance} from "../helpers/distance";

export class SetKickYardCommand implements Command {
  constructor(
    private gamePlay: GamePlay,
    private caughtOnYardLine: string) { }

  execute() {
    console.log('COMMAND SetKickYardCommand', this.caughtOnYardLine)
    this.gamePlay.kickYards = getDistance(this.gamePlay.yardLine, this.caughtOnYardLine)
  }
}
